import { render, staticRenderFns } from "./IcraDairesiList.vue?vue&type=template&id=4e9d2221"
import script from "./IcraDairesiList.vue?vue&type=script&lang=ts"
export * from "./IcraDairesiList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports